module.exports = "<p>\r\n  table-tramitar-executiva-olot works!\r\n</p>\r\n"